export enum PartnerPlacement {
	Basic = "Basic",
	Crm = "Crm",
	Integrations = "Integrations",
	HR = "HR",
	Gastro = "Gastro",
	Accounting = "Accounting",
	Transport = "Transport",
	Production = "Production",
}
